import { FetcherWithComponents } from "react-router-dom";

export function resetFetcher<T = any>(fetcher: FetcherWithComponents<T>) {
  fetcher.submit({}, { action: "/reset-fetcher", method: "post" });
}

export function action() {
  return null;
}
